import { Check, X } from "lucide-react";

const reachedIndex = (data) => {
  const { statuses, status, milestones } = data;
  if (status !== "Cancelled") return statuses.indexOf(status);
  return Math.max(-1, ...milestones.map((m) => statuses.indexOf(m.status)));
};

const stateOf = (i, current, cancelled, delivered) => {
  if (i < current || (delivered && i === current)) return "completed";
  if (i === current && !cancelled) return "current";
  return cancelled && i > current ? "skipped" : "upcoming";
};

const Dot = ({ state, n }) => {
  const base = "w-9 h-9 grid place-items-center shrink-0 font-mono text-xs font-bold border-2 transition-colors";
  if (state === "completed") return <span className={`${base} bg-brand-600 border-brand-600 text-white`}><Check className="w-4 h-4" /></span>;
  if (state === "current") return <span className={`${base} bg-white border-brand-600 text-brand-600 pulse-ring-blue`}>{n}</span>;
  return <span className={`${base} bg-white border-slate-300 text-slate-500`}>{n}</span>;
};

export const StatusTimeline = ({ data }) => {
  const cancelled = data.status === "Cancelled";
  const delivered = data.status === "Delivered";
  const current = reachedIndex(data);
  return (
    <div data-testid="status-timeline">
      {cancelled && (
        <div className="mb-6 flex items-center gap-3 px-4 py-3 border border-red-500/40 bg-red-500/10 text-red-700 text-sm" data-testid="timeline-cancelled">
          <X className="w-4 h-4" /> This shipment was cancelled.
        </div>
      )}
      <ol className="grid gap-0 lg:grid-cols-8">
        {data.statuses.map((s, i) => {
          const st = stateOf(i, current, cancelled, delivered);
          const last = i === data.statuses.length - 1;
          return (
            <li key={s} className="relative flex lg:flex-col items-start lg:items-center gap-4 lg:gap-3 pb-6 lg:pb-0" data-testid={`timeline-stage-${i}`} data-state={st}>
              {!last && <span className={`absolute left-[17px] top-9 bottom-0 w-0.5 lg:left-1/2 lg:top-[17px] lg:w-full lg:h-0.5 lg:bottom-auto ${i < current || (delivered && i < current) ? "bg-brand-600" : "bg-slate-200"}`} />}
              <span className="relative z-[1]"><Dot state={st} n={i + 1} /></span>
              <div className="lg:text-center pt-1.5 lg:pt-0">
                <div className={`font-display uppercase tracking-wide font-semibold text-sm leading-tight ${st === "upcoming" || st === "skipped" ? "text-slate-500" : "text-slate-900"} ${st === "current" ? "!text-brand-600" : ""}`}>{s}</div>
                <div className="font-mono text-[9px] uppercase tracking-[0.2em] text-slate-500 mt-1">{st}</div>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
